import { List } from 'antd';

const ListItemMeta = props => <List.Item.Meta {...props} />;

export default ListItemMeta;
